export default __webpack_public_path__ + "static/media/BCA22.7b764207.jpg";